<div class="modal fade" data-backdrop="static" data-keyboard="false" id="{{modalID}}">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
    @if (aviso!=null) {
      <div class="modal-content">
        <div class="modal-body">
          <h3>{{aviso.TITULO}}</h3>
          <div class="my-3">
            {{aviso.DESCRICAO}}
          </div>
          <div class="row">
            <div class="col">
              <ul class="list-unstyled">
                @for (item of arquivos; track item) {
                  <li class="d-inline pr-2">
                    <a href="" (click)="download(item.HASH_COD_ARQUIVO, item.NOME); false">{{item.NOME}}</a>
                  </li>
                }
              </ul>
            </div>
            2
            <div class="col text-right">
              @if (aviso.DEC_OBRIGA_ACEITE=='S' && aviso.TIM_ACEITE==null) {
                <label for="ckAceito" style="cursor: pointer; font-weight: bold;">
                  Li e aceito
                  <input type="checkbox" id="ckAceito" [(ngModel)]="aceito" (change)="gravarAceite(aviso.COD_AVI_AVISO)">
                </label>
              }
              @if (aviso.DEC_OBRIGA_ACEITE=='N' || aviso.TIM_ACEITE!=null) {
                <button class="btn btn-success" (click)="fecharModal()">
                  Ok
                </button>
              }
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>